import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { MegaMenuProvider } from './context/MegaMenuContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FavoritesProvider>
      <CartProvider>
        <BrowserRouter>
          <MegaMenuProvider>
            <App />
          </MegaMenuProvider>
        </BrowserRouter>
      </CartProvider>
    </FavoritesProvider>
  </React.StrictMode>
);
